import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IHttpSingleDataResponse } from '@irembo-andela/irembogov3-common';
import { ICertificateTemplate } from '../models/certificate-template-model';
import { ICreateCertificateRequest } from '../models/http/create-certificate-request.model';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private http: HttpClient) {}

  createCertificate(
    request: ICreateCertificateRequest
  ): Observable<IHttpSingleDataResponse<ICertificateTemplate>> {
    const formData = new FormData();

    (
      Object.entries(request) as [keyof ICreateCertificateRequest, any][]
    ).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    const headers = new HttpHeaders({});
    return this.http.post<IHttpSingleDataResponse<ICertificateTemplate>>(
      `${environment.apiGatewayBaseUrl}/document-generation/v1/create-template`,
      formData,
      { headers }
    );
  }
}
